import React from 'react';
import { FaPlane, FaShip, FaWarehouse } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import './Services.css';

function Services() {
  const services = [
    {
      title: 'Air Freight',
      desc: 'Fast & reliable global air cargo delivery for urgent shipments.',
      icon: <FaPlane size={50} className="text-success mb-3" />,
      aos: 'fade-right',
      link: '/air-freight'
    },
    {
      title: 'Sea Freight',
      desc: 'Cost-effective and efficient sea transportation across continents.',
      icon: <FaShip size={50} className="text-success mb-3" />,
      aos: 'fade-left',
      link: '/sea-freight'
    },
    {
      title: 'Warehousing',
      desc: 'Secure and scalable warehousing solutions with real-time tracking.',
      icon: <FaWarehouse size={50} className="text-success mb-3" />,
      aos: 'fade-right',
      link: '/warehousing'
    }
  ];

  return (
    <section id="services" className="services-section py-5">
      <div className="container text-center">
        <h2 className="fw-bold text-success mb-4" data-aos="fade-up">
          Our Services
        </h2>

        <p className="lead text-muted mb-5" data-aos="fade-up">
          We offer complete logistics and supply chain solutions — moving your business forward with reliability and trust.
        </p>

        <div className="row g-4 justify-content-center">
          {services.map((service, index) => (
            <div
              className="col-11 col-sm-6 col-lg-4 d-flex justify-content-center"
              key={index}
              data-aos={service.aos}
            >
              <Link to={service.link} className="text-decoration-none text-dark w-100">
                <div className="service-card shadow-sm p-4 bg-white rounded text-center h-100">
                  <div className="icon-wrapper mx-auto">{service.icon}</div>
                  <h5 className="fw-bold mt-3">{service.title}</h5>
                  <p className="text-muted small">{service.desc}</p>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;
